// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"235":"35c0b4ce","696":"e5187041","853":"dcddff5c"}[chunkId] + ".css";
};